import { ReactElement } from 'react';
import { LabelTabOptionsRes } from '../loaders/labelTab.resolver';
import {
  ArticleGeneralTabDataRes,
  ArticleProductionTabDataRes,
  CashAssistTabOptionsRes,
  GeneralTabOptionsRes,
  ProductionTabOptionsRes,
} from '../services/article.service';
import { FieldErrors } from 'react-hook-form';
import { IDefaultOrderState } from '../components/tabs/defaultOrder/defaultOrder.state.ts';
import { DictCustomersRes } from '../../../shared/services/configsData/configsData.service.ts';

export enum ArticleTabs {
  general = 'general',
  lists = 'lists',
  availability = 'availability',
  production = 'production',
  label = 'label',
  cashAssist = 'cashAssist',
  post = 'post',
  defaultOrder = 'defaultOrder',
}
export interface IDefaultOrderTabOptions {
  customerList?: DictCustomersRes;
}
export interface ITabState {
  articleId: string;
  isDough: boolean;
  defaultValues: any;
  articleSpecialPrices: ArticleGeneralTabDataRes['articleSpecialPrices'];
  articlePricesByCustomers: ArticleGeneralTabDataRes['articlePricesByCustomers'];
  articleResellerPrices: ArticleGeneralTabDataRes['articleResellerPrices'];
  articleProductionCalculation: ArticleProductionTabDataRes['articleProductionCalculation'];
  specialPriceCategoriesColumns: ReactElement[] | any;
  createSpecialPriceCategoriesInputs: (
    focusedField: string,
    errors: FieldErrors,
  ) => ReactElement | any;
  generalTabOptions: GeneralTabOptionsRes | object;
  generalPriceCategories: React.ReactElement[] | [];
  cashAssistTabOptions: CashAssistTabOptionsRes | object;
  productionTabOptions: ProductionTabOptionsRes | object;
  labelTabOptions: LabelTabOptionsRes | object;
  defaultOrderTabData: IDefaultOrderState | object;
  defaultOrderTabOptions: IDefaultOrderTabOptions;
}
export const tabStateModel: ITabState = {
  articleId: '',
  isDough: false,
  defaultValues: {},
  generalTabOptions: {},
  generalPriceCategories: [],
  cashAssistTabOptions: {},
  productionTabOptions: {},
  labelTabOptions: {},
  articleSpecialPrices: [],
  articlePricesByCustomers: [],
  articleResellerPrices: [],
  specialPriceCategoriesColumns: [],
  articleProductionCalculation: [],
  createSpecialPriceCategoriesInputs: () => null,
  defaultOrderTabData: {},
  defaultOrderTabOptions: {},
};
